module.exports = __webpack_public_path__ + "img/online.60500360.png";